export default __webpack_public_path__ + "static/media/npsimple2.22ad5000.png";